import apiConfig from '../../../shared/config/apiConfig'
import { createApiClient } from '../../../shared/api/apiClient'
import { getUserSession } from '../../../shared/authentication/helpers/sessionStorage'

export const createChatService = ({
  apiClient,
  axiosInstance,
  apiKey = apiConfig.apiKey || '',
  baseUrl = apiConfig.brandAPIs?.CHAT || '',
  getSession = getUserSession,
} = {}) => {
  const getChatSession = () => {
    const session = getSession() || {}
    const token = session.accessToken || ''
    return {
      ...session,
      accessToken:
        token && !token.startsWith('Bearer ') ? `Bearer ${token}` : token,
    }
  }
  const client =
    apiClient ||
    createApiClient({
      apiKey,
      axiosInstance,
      baseUrl,
      getSession: getChatSession,
    })
  if (!apiClient) {
    client.addRequestInterceptor((request) => {
      const session = getSession() || {}
      const groupHeader = (session.memberOf || [])
        .filter((group) => group.toUpperCase().includes('BRAND-DNA'))
        .map((group) =>
          group.includes('=')
            ? group
            : `CN=${group},OU=Application,OU=Groupings,DC=corp,DC=target,DC=com`,
        )[0]

      return {
        ...request,
        headers: {
          ...request.headers,
          ...(session.xIdToken && { 'x-id-token': session.xIdToken }),
          ...(apiKey && { 'x-api-key': apiKey }),
          ...(groupHeader && { 'x-tgt-memberof': groupHeader }),
        },
      }
    })
  }

  return {
    archiveSession: (sessionId, status) =>
      client.patch(`/chat/sessions/${encodeURIComponent(sessionId)}`, {
        body: { status },
      }),
    createSession: (brand) =>
      client.post('/chat/sessions', {
        body: brand ? { brand } : {},
      }),
    deleteSession: (sessionId) =>
      client.delete(`/chat/sessions/${encodeURIComponent(sessionId)}`),
    getSession: (sessionId, { cursor, limit = 50 } = {}) =>
      client.get(`/chat/sessions/${encodeURIComponent(sessionId)}`, {
        params: { cursor, limit },
      }),
    listSessions: ({ cursor, limit = 50, status = 'ACTIVE' } = {}) =>
      client.get('/chat/sessions', { params: { cursor, limit, status } }),
    rateExchange: (exchangeId, feedback) =>
      client.patch(
        `/chat/exchanges/${encodeURIComponent(exchangeId)}/feedback`,
        { body: { feedback } },
      ),
    renameSession: (sessionId, title) =>
      client.patch(`/chat/sessions/${encodeURIComponent(sessionId)}`, {
        body: { title },
      }),
    retryExchange: (exchangeId) =>
      client.post(`/chat/exchanges/${encodeURIComponent(exchangeId)}/retry`),
    sendMessage: (query, sessionId, clientRequestId, brand) =>
      client.post('/query', {
        body: {
          ...(brand ? { brand } : {}),
          client_request_id: clientRequestId,
          mode: 'auto',
          query,
          session_id: sessionId,
        },
        timeout: 120000,
      }),
  }
}

export const chatService = createChatService()
